
import { Component, Mixins } from "vue-property-decorator";
import {
  Document,
} from "../../../../domain/document";
import { EditingDocument } from "..";

@Component({
})
export default class DocumentEditInformationEditableMixin extends Mixins() {
  editingSource: EditingDocument;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get scale(): number {
    return this.readPropertyOrDefault(s => s.scale, 1.0);
  }

  set scale(source: number) {
    this.writePropertyWhenValid(s => s.scale = source);
  }

  get shouldDrawEditStyle(): boolean {
    return this.readPropertyOrDefault(s => s.shouldDrawEditStyle, true);
  }

  set shouldDrawEditStyle(source: boolean) {
    this.writePropertyWhenValid(s => s.shouldDrawEditStyle = source);
  }

  get shouldDrawTransparentAll(): boolean {
    return this.readPropertyOrDefault(s => s.shouldDrawTransparentAll, false);
  }

  set shouldDrawTransparentAll(source: boolean) {
    this.writePropertyWhenValid(s => s.shouldDrawTransparentAll = source);
  }

  get shouldMarkQuote(): boolean {
    return this.readPropertyOrDefault(s => s.shouldMarkQuote, false);
  }

  set shouldMarkQuote(source: boolean) {
    this.writePropertyWhenValid(s => s.shouldMarkQuote = source);
  }

  get shouldInputFreeAll(): boolean {
    return this.readPropertyOrDefault(s => s.shouldInputFreeAll, false);
  }

  set shouldInputFreeAll(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldInputFreeAll = value);
  }

  get documentSource(): Document {
    return this.readPropertyOrDefault(s => s.source, null);
  }
}
